import React, { useState, useEffect, useContext } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import { AuthContext } from "../../auth/AuthContext";
import { request } from "../../utils/api";
import Loading from "../yobas/utilComponent/Loading";
import adminImg from "../../../assets/img/images/admin.jpg";
import depositImg from "../../../assets/img/images/deposit.png";
import labelImg from "../../../assets/img/images/label.png";
import memberImg from "../../../assets/img/images/member.png";
import orderImg from "../../../assets/img/images/order.png";
import paymentImg from "../../../assets/img/images/payment.png";
import prepImg from "../../../assets/img/images/prep.png";
import productImg from "../../../assets/img/images/product.png";
import trackingImg from "../../../assets/img/images/tracking.png";
import warehouseImg from "../../../assets/img/images/warehouse.png";
import DateRangeFilter from "../yobas/utilComponent/DateRangeFilter";

const formatCurrency = (value) => `$${Number(value || 0).toLocaleString()}`;
const formatCompact = (value) =>
  new Intl.NumberFormat("en", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(Number(value || 0));

const getAccentClass = (index) => {
  const accents = [
    "accent-indigo",
    "accent-cyan",
    "accent-amber",
    "accent-emerald",
    "accent-rose",
    "accent-sky",
  ];
  return accents[index % accents.length];
};

const CrmStyles = () => (
  <style>{`
    .crm-dashboard {
      min-height: 85vh;
      background:
        radial-gradient(circle at 8% 4%, rgba(14, 116, 255, 0.08), transparent 42%),
        radial-gradient(circle at 95% 0%, rgba(16, 185, 129, 0.08), transparent 40%),
        #f5f8fc;
    }
    .crm-hero {
      border-radius: 18px;
      border: 1px solid rgba(16,37,66,.08);
      background: linear-gradient(180deg, rgba(255,255,255,.98), rgba(246,250,255,.95));
      box-shadow: 0 16px 35px rgba(16,37,66,.07);
      padding: 1rem;
    }
    .crm-hero__title {
      margin: 0;
      font-size: 1.35rem;
      font-weight: 700;
      color: #102542;
      letter-spacing: -.02em;
    }
    .crm-hero__subtitle {
      margin: .35rem 0 0;
      font-size: .9rem;
      color: #6a7b92;
    }
    .crm-pill {
      display: inline-flex;
      align-items: center;
      gap: .4rem;
      padding: .45rem .75rem;
      border-radius: 999px;
      border: 1px solid rgba(16,37,66,.08);
      background: rgba(255,255,255,.9);
      color: #274768;
      font-size: .78rem;
      font-weight: 600;
    }
    .crm-filter-shell {
      border-radius: 14px;
      border: 1px solid rgba(16,37,66,.06);
      background: rgba(255,255,255,.75);
      padding: .75rem;
    }
    .crm-kpi-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
      gap: 1rem;
    }
    .crm-kpi-card {
      position: relative;
      border-radius: 16px;
      border: 1px solid rgba(16,37,66,.08);
      background: linear-gradient(180deg, #fff, #fbfdff);
      box-shadow: 0 12px 26px rgba(16,37,66,.06);
      transition: transform .18s ease, box-shadow .18s ease;
      overflow: hidden;
      min-height: 108px;
    }
    .crm-kpi-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 16px 30px rgba(16,37,66,.09);
    }
    .crm-kpi-card::before {
      content: "";
      position: absolute;
      inset: 0 auto auto 0;
      width: 100%;
      height: 4px;
      background: linear-gradient(90deg, #4f46e5, #3b82f6);
    }
    .crm-kpi-card.accent-cyan::before { background: linear-gradient(90deg, #0891b2, #06b6d4); }
    .crm-kpi-card.accent-amber::before { background: linear-gradient(90deg, #d97706, #f59e0b); }
    .crm-kpi-card.accent-emerald::before { background: linear-gradient(90deg, #059669, #10b981); }
    .crm-kpi-card.accent-rose::before { background: linear-gradient(90deg, #e11d48, #fb7185); }
    .crm-kpi-card.accent-sky::before { background: linear-gradient(90deg, #0284c7, #38bdf8); }
    .crm-kpi-icon {
      width: 64px;
      height: 64px;
      border-radius: 14px;
      border: 1px solid rgba(16,37,66,.06);
      background: linear-gradient(135deg, #f2f7ff, #fff);
      box-shadow: inset 0 1px 0 rgba(255,255,255,.85);
      flex-shrink: 0;
    }
    .crm-kpi-label {
      text-transform: uppercase;
      letter-spacing: .08em;
      font-weight: 700;
      font-size: .74rem;
      color: #73849b;
      margin-bottom: .2rem;
      line-height: 1.2;
    }
    .crm-kpi-value {
      font-size: 1.35rem;
      font-weight: 700;
      color: #102542;
      line-height: 1.2;
    }
    .crm-kpi-meta {
      font-size: .82rem;
      color: #7b8ba0;
      margin-top: .15rem;
    }
    .crm-dashboard .row-deck > [class*="col-"] > .card,
    .crm-dashboard .row-deck > .col > .card {
      border-radius: 18px;
      border: 1px solid rgba(16,37,66,.08);
      background: linear-gradient(180deg, rgba(255,255,255,.98), rgba(250,252,255,.96));
      box-shadow: 0 14px 28px rgba(16,37,66,.06);
      overflow: hidden;
    }
    .crm-dashboard .card-header {
      background: transparent;
      border-bottom: 1px solid rgba(16,37,66,.06);
      padding: .95rem 1rem;
    }
    .crm-dashboard .card-title {
      color: #102542;
      font-weight: 700;
      letter-spacing: -.01em;
    }
    .crm-dashboard .card-body {
      padding: .85rem;
    }
    .crm-dashboard .card-fullscreen {
      width: 34px;
      height: 34px;
      border-radius: 10px;
      border: 1px solid rgba(16,37,66,.08);
      background: #fff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #57677d;
      transition: all .15s ease;
    }
    .crm-dashboard .card-fullscreen:hover {
      background: #f3f7fd;
      color: #17395c;
      border-color: rgba(23,57,92,.16);
    }
    .crm-section-note {
      margin: 0 0 .25rem;
      color: #6f8098;
      font-size: .8rem;
    }
    @media (max-width: 767px) {
      .crm-hero { border-radius: 14px; padding: .9rem; }
      .crm-hero__title { font-size: 1.15rem; }
      .crm-dashboard .card-header { padding: .8rem; }
      .crm-dashboard .card-body { padding: .7rem; }
      .crm-kpi-grid { grid-template-columns: 1fr; }
      .crm-kpi-card { min-height: 96px; }
      .crm-kpi-icon { width: 56px; height: 56px; }
      .crm-kpi-value { font-size: 1.15rem; }
    }
  `}</style>
);

const Crm = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({});
  const [date, setDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const roleKey = user?.role_key;
  const isAdmin = roleKey === "super_admin";
  const admin = roleKey === "admin";
  const isPrepTeam = user?.role_key === "prep_team";
  const isTrackTeam = user?.role_key === "track_team";
  const isMember = user?.role_key === "member";

  // Role-based access control (charts/sections)
  const canViewFinancial = isAdmin || admin;
  const canViewTeamStats = isAdmin || admin;
  const canViewProducts = isAdmin || admin;
  const canViewTracking = isAdmin || admin || isTrackTeam;
  const canViewLabels =
    isAdmin || admin || isPrepTeam || isTrackTeam || isMember;

  // Role-based dashboard card filtering (frontend only; backend should still scope API data)
  const dashboardCardAccessByRole = {
    super_admin: [
      "total_admins",
      "total_products",
      "total_order",
      "total_payment",
      "total_deposit",
      "total_labels",
      "total_cost_sum",
      "total_label_uploaded",
      "total_label_printed",
      "total_label_out_of_stock",
    ],
    admin: [
      "total_prep_team",
      "total_tracking_team",
      "total_warehouse",
      "total_products",
      "total_order",
      "total_payment",
      "total_deposit",
      "total_cost_sum",
      "total_label_uploaded",
      "total_label_printed",
      "total_label_out_of_stock",
    ],
    prep_team: [
      "total_warehouse",
      "total_label_uploaded",
      "total_label_printed",
      "total_label_out_of_stock",
      "total_cost_sum",
      "total_deposit",
      "total_balance",
    ],
    track_team: [
      "total_label_uploaded",
      "total_label_printed",
      "total_label_out_of_stock",
    ],
    member: [
      "total_label_uploaded",
      "total_payment",
      "total_deposit",
      "total_label_printed",
      "total_label_out_of_stock",
    ],
  };

  const allowedDashboardCardKeys = dashboardCardAccessByRole[roleKey] || [];
  const canViewDashboardCard = (key) => allowedDashboardCardKeys.includes(key);

  const [barSeries, setBarSeries] = useState([]);
  const [barOptions, setBarOptions] = useState({});
  const [outboundSeries, setOutboundSeries] = useState([]);
  const [outboundOptions, setOutboundOptions] = useState({});
  const [revenueSeries, setRevenueSeries] = useState([]);
  const [revenueOptions, setRevenueOptions] = useState({});
  const [teamSeries, setTeamSeries] = useState([]);
  const [teamOptions, setTeamOptions] = useState({});
  const [orderSeries, setOrderSeries] = useState([]);
  const [orderOptions, setOrderOptions] = useState({});
  const [productServiceSeries, setProductServiceSeries] = useState([]);
  const [productServiceOptions, setProductServiceOptions] = useState({});
  const [labelStatusSeries, setLabelStatusSeries] = useState([]);
  const [labelStatusOptions, setLabelStatusOptions] = useState({});

  const getDashboardData = async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams();
      if (date) {
        params.append("from_date", date);
        params.append("to_date", date);
      } else if (fromDate && toDate) {
        params.append("from_date", fromDate);
        params.append("to_date", toDate);
      } else if (fromDate) {
        params.append("from_date", fromDate);
      } else if (toDate) {
        params.append("to_date", toDate);
      }

      const response = await request({
        url: `dashboard/counts?${params.toString()}`,
        method: "GET",
      });

      const data = response.data;
      setDashboardData(data);

      // Generate monthly data distribution (simulated - replace with actual API data if available)
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const generateMonthlyData = (total, variance = 0.3) => {
        const avg = total / 12;
        return months.map(() => {
          const variation = (Math.random() - 0.5) * variance;
          return Math.max(0, Math.round(avg * (1 + variation)));
        });
      };

      // Sales Statistics Bar Chart
      const paymentData = generateMonthlyData(data.total_payment || 0);
      const depositData = generateMonthlyData(data.total_deposit || 0);

      setBarSeries([
        { name: "Payment", data: paymentData },
        { name: "Deposit", data: depositData },
      ]);

      setBarOptions({
        chart: {
          type: "bar",
          height: 320,
          stacked: true,
          toolbar: { show: false },
          zoom: { enabled: true },
        },
        colors: ["var(--chart-color1)", "var(--chart-color5)"],
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
            columnWidth: "55%",
          },
        },
        xaxis: {
          categories: months,
          labels: { style: { fontSize: "12px" } },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val >= 1000 ? (val / 1000).toFixed(1) + "K" : val;
            },
          },
        },
        dataLabels: { enabled: false },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "14px",
        },
        fill: { opacity: 1 },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$" + val.toLocaleString();
            },
          },
        },
      });

      // Outbound Calls & Contact Rate Chart
      const servicesData = generateMonthlyData(data.total_services || 0);
      const productsData = generateMonthlyData(data.total_products || 0);

      setOutboundSeries([
        { name: "Services", type: "column", data: servicesData },
        { name: "Products", type: "line", data: productsData },
      ]);

      setOutboundOptions({
        chart: {
          height: 350,
          type: "line",
          toolbar: { show: false },
          zoom: { enabled: true },
        },
        stroke: { width: [0, 4], curve: "smooth" },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
          style: { fontSize: "11px", fontWeight: 600 },
        },
        colors: ["var(--chart-color1)", "var(--chart-color2)"],
        xaxis: {
          categories: months,
          labels: { style: { fontSize: "12px" } },
        },
        yaxis: [
          {
            title: { text: "Services", style: { fontSize: "12px" } },
            labels: { style: { fontSize: "11px" } },
          },
          {
            opposite: true,
            title: { text: "Products", style: { fontSize: "12px" } },
            labels: { style: { fontSize: "11px" } },
          },
        ],
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "14px",
        },
        fill: {
          opacity: [0.85, 1],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
      });

      // Revenue Distribution Donut Chart
      const revenueTotal =
        (data.total_payment || 0) + (data.total_deposit || 0);
      setRevenueSeries([
        data.total_payment || 0,
        data.total_deposit || 0,
        data.total_balance || 0,
      ]);

      setRevenueOptions({
        chart: {
          type: "donut",
          height: 320,
          toolbar: { show: false },
        },
        labels: ["Total Payment", "Total Deposit", "Total Balance"],
        colors: [
          "var(--chart-color1)",
          "var(--chart-color5)",
          "var(--chart-color3)",
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toFixed(1) + "%";
          },
          style: {
            fontSize: "12px",
            fontWeight: 600,
          },
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "13px",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "14px",
                  fontWeight: 600,
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  fontWeight: 700,
                  formatter: function (val) {
                    return "$" + val.toLocaleString();
                  },
                },
                total: {
                  show: true,
                  label: "Total Revenue",
                  fontSize: "14px",
                  fontWeight: 600,
                  formatter: function () {
                    return "$" + revenueTotal.toLocaleString();
                  },
                },
              },
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$" + val.toLocaleString();
            },
          },
        },
      });

      // Team Performance Area Chart
      const prepTeamData = generateMonthlyData(data.total_prep_team || 0, 0.2);
      const trackingTeamData = generateMonthlyData(
        data.total_tracking_team || 0,
        0.2,
      );
      const memberData = generateMonthlyData(data.total_member || 0, 0.2);

      setTeamSeries([
        { name: "Prep Team", data: prepTeamData },
        { name: "Tracking Team", data: trackingTeamData },
        { name: "Members", data: memberData },
      ]);

      setTeamOptions({
        chart: {
          type: "area",
          height: 320,
          stacked: true,
          toolbar: { show: false },
          zoom: { enabled: true },
        },
        colors: [
          "var(--chart-color1)",
          "var(--chart-color2)",
          "var(--chart-color3)",
        ],
        stroke: {
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
            stops: [0, 100],
          },
        },
        xaxis: {
          categories: months,
          labels: { style: { fontSize: "12px" } },
        },
        yaxis: {
          labels: {
            style: { fontSize: "11px" },
            formatter: function (val) {
              return Math.round(val);
            },
          },
        },
        dataLabels: { enabled: false },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "14px",
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
      });

      // Order Trends Line Chart
      const orderData = generateMonthlyData(data.total_order || 0);
      const clientData = generateMonthlyData(data.total_client || 0);

      setOrderSeries([
        { name: "Orders", data: orderData },
        { name: "Clients", data: clientData },
      ]);

      setOrderOptions({
        chart: {
          type: "line",
          height: 320,
          toolbar: { show: false },
          zoom: { enabled: true },
        },
        colors: ["var(--chart-color1)", "var(--chart-color4)"],
        stroke: {
          curve: "smooth",
          width: 3,
        },
        markers: {
          size: 5,
          hover: {
            size: 7,
          },
        },
        xaxis: {
          categories: months,
          labels: { style: { fontSize: "12px" } },
        },
        yaxis: {
          labels: {
            style: { fontSize: "11px" },
            formatter: function (val) {
              return Math.round(val);
            },
          },
        },
        dataLabels: { enabled: false },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "14px",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
      });

      // Products vs Services Pie Chart
      setProductServiceSeries([
        data.total_products || 0,
        data.total_services || 0,
      ]);

      setProductServiceOptions({
        chart: {
          type: "pie",
          height: 320,
          toolbar: { show: false },
        },
        labels: ["Products", "Services"],
        colors: ["var(--chart-color1)", "var(--chart-color2)"],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toFixed(1) + "%";
          },
          style: {
            fontSize: "13px",
            fontWeight: 600,
          },
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "14px",
        },
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              labels: {
                show: false,
              },
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toLocaleString();
            },
          },
        },
      });

      // Label Status Chart (for Prep Team, Tracking Team, and Members)
      setLabelStatusSeries([
        data.total_label_printed || 0,
        data.total_label_uploaded || 0,
        data.total_label_out_of_stock || 0,
      ]);

      setLabelStatusOptions({
        chart: {
          type: "bar",
          height: 320,
          toolbar: { show: false },
        },
        labels: ["Labels Printed", "Labels Uploaded", "Labels Out of Stock"],
        colors: [
          "var(--chart-color1)",
          "var(--chart-color2)",
          "var(--chart-color5)",
        ],
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
            columnWidth: "55%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toLocaleString();
          },
          style: {
            fontSize: "12px",
            fontWeight: 600,
          },
        },
        xaxis: {
          categories: ["Printed", "Uploaded", "Out of Stock"],
          labels: { style: { fontSize: "12px" } },
        },
        yaxis: {
          labels: {
            style: { fontSize: "11px" },
            formatter: function (val) {
              return Math.round(val);
            },
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toLocaleString();
            },
          },
        },
      });
    } catch (error) {
      console.error("Failed to fetch dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDashboardData();
  }, [fromDate, toDate]);

  // Dashboard cards - shown only if API returns data for that key (not role-based)
  // Charts are role-based, but cards depend on API response
  const dashboardCards = [
    { key: "total_admins", title: "Total Admins", img: adminImg },
    { key: "total_labels", title: "Total Labels", img: labelImg },
    { key: "total_member", title: "Total Members", img: memberImg },
    { key: "total_prep_team", title: "Prep Team", img: prepImg },
    { key: "total_tracking_team", title: "Tracking Team", img: trackingImg },
    { key: "total_products", title: "Products", img: productImg },
    { key: "total_services", title: "Services", img: productImg },
    {
      key: "total_payment",
      title: "Total Payment",
      img: paymentImg,
      money: true,
    },
    {
      key: "total_deposit",
      title: "Total Deposit",
      img: depositImg,
      money: true,
    },
    {
      key: "total_balance",
      title: "Total Balance",
      img: paymentImg,
      money: true,
    },
    { key: "total_warehouse", title: "Total Warehouses", img: warehouseImg },
    { key: "total_discount", title: "Total Discount", img: depositImg },
    { key: "total_order", title: "Total Orders", img: orderImg },
    { key: "total_client", title: "Total Clients", img: memberImg },
    { key: "total_cost_sum", title: "Total Cost Sum", img: depositImg },
    { key: "total_label_printed", title: "Labels Printed", img: labelImg },
    {
      key: "total_label_out_of_stock",
      title: "Labels Out of Stock",
      img: labelImg,
    },
    { key: "total_label_uploaded", title: "Labels Uploaded", img: labelImg },
  ];

  const [saleFullScreen, setSaleFullScreen] = useState(false);
  const [outboundFullScreen, setOutboundFullScreen] = useState(false);
  const [revenueFullScreen, setRevenueFullScreen] = useState(false);
  const [teamFullScreen, setTeamFullScreen] = useState(false);
  const [orderFullScreen, setOrderFullScreen] = useState(false);
  const [productServiceFullScreen, setProductServiceFullScreen] =
    useState(false);
  const [labelStatusFullScreen, setLabelStatusFullScreen] = useState(false);

  const handleFullScreen = () => setOutboundFullScreen(!outboundFullScreen);
  const handleFullScreen2 = () => setSaleFullScreen(!saleFullScreen);
  const handleFullScreen3 = () => setRevenueFullScreen(!revenueFullScreen);
  const handleFullScreen4 = () => setTeamFullScreen(!teamFullScreen);
  const handleFullScreen5 = () => setOrderFullScreen(!orderFullScreen);
  const handleFullScreen6 = () =>
    setProductServiceFullScreen(!productServiceFullScreen);
  const handleFullScreen7 = () =>
    setLabelStatusFullScreen(!labelStatusFullScreen);

  const handleDateRangeChange = ({ fromDate, toDate }) => {
    setDate("");
    setFromDate(fromDate);
    setToDate(toDate);
  };

  const visibleCards = dashboardCards.filter(
    ({ key }) =>
      canViewDashboardCard(key) && dashboardData?.[key] !== undefined,
  );

  const visibleMonetaryTotal = [
    "total_payment",
    "total_deposit",
    "total_balance",
  ]
    .filter(
      (key) => canViewDashboardCard(key) && dashboardData?.[key] !== undefined,
    )
    .reduce((sum, key) => sum + Number(dashboardData?.[key] || 0), 0);

  return (
    <div className="crm-dashboard">
      <CrmStyles />
      <div className="page-toolbar px-xl-4 px-sm-2 px-0 py-3">
        <div className="container-fluid">
          <div className="crm-hero">
            <ol className="breadcrumb bg-transparent mb-2 px-0">
              <li className="breadcrumb-item">
                <Link className="text-secondary" to="/">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Dashboard
              </li>
            </ol>

            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div>
                <h1 className="crm-hero__title">Youbase Dashboard</h1>
                <p className="crm-hero__subtitle">
                  Monitor finance, team productivity, labels, and fulfillment
                  trends in one cleaner workspace.
                </p>
              </div>
            </div>

            <div className="d-flex flex-wrap gap-2 mt-3">
              <span className="crm-pill">
                <i className="fa fa-th-large" aria-hidden="true"></i>
                {visibleCards.length} metrics visible
              </span>
              <span className="crm-pill">
                <i className="fa fa-usd" aria-hidden="true"></i>
                {formatCurrency(visibleMonetaryTotal)} tracked value
              </span>
              <span className="crm-pill">
                <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                {(roleKey || "unknown").replaceAll("_", " ")}
              </span>
            </div>

            <div className="crm-filter-shell mt-3">
              <p className="crm-section-note">
                Apply a date range to refresh dashboard totals and chart
                snapshots.
              </p>
              <div className="row g-3 align-items-end">
                <DateRangeFilter onChange={handleDateRangeChange} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-body px-xl-4 px-sm-2 px-0 py-lg-2 py-1 mt-0 mt-lg-3">
        <div className="container-fluid">
          {loading ? (
            <Loading />
          ) : (
            <div className="crm-kpi-grid mb-4">
              {dashboardCards.map(
                ({ key, title, img, money }, index) =>
                  canViewDashboardCard(key) &&
                  dashboardData?.[key] !== undefined && (
                    <DashboardCard
                      key={key}
                      title={title}
                      value={
                        money ? `$${dashboardData[key]}` : dashboardData[key]
                      }
                      img={img}
                      money={money}
                      accentClass={getAccentClass(index)}
                    />
                  ),
              )}
            </div>
          )}

          {/* Label Status Chart - For Prep Team, Tracking Team, and Members */}
          {(canViewLabels || isTrackTeam) && (
            <div className="row g-3 mb-4 row-deck">
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div
                  className={labelStatusFullScreen ? "card fullscreen" : "card"}
                >
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title m-0">
                      <i className="fa fa-bar-chart me-2"></i>Label Status
                      Overview
                    </h6>
                    <Link
                      className="card-fullscreen"
                      onClick={handleFullScreen7}
                    >
                      <i className="icon-size-fullscreen"></i>
                    </Link>
                  </div>
                  <div className="card-body">
                    {labelStatusSeries.length > 0 && (
                      <ReactApexChart
                        options={labelStatusOptions}
                        series={[{ name: "Labels", data: labelStatusSeries }]}
                        type="bar"
                        height={320}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/* Sales Statistics Bar Chart */}
              {canViewFinancial && (
                <div className="col-xl-6 col-lg-12 col-md-12">
                  <div className={saleFullScreen ? "card fullscreen" : "card"}>
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h6 className="card-title m-0">
                        <i className="fa fa-bar-chart me-2"></i>Sales Statistics
                      </h6>
                      <Link
                        className="card-fullscreen"
                        onClick={handleFullScreen2}
                      >
                        <i className="icon-size-fullscreen"></i>
                      </Link>
                    </div>
                    <div className="card-body">
                      {barSeries.length > 0 && (
                        <ReactApexChart
                          options={barOptions}
                          series={barSeries}
                          type="bar"
                          height={320}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {/* Charts Section - Role-based visibility */}
          {canViewFinancial && (
            <div className="row g-3 mb-4 row-deck">
              {/* Revenue Distribution Donut Chart */}
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div className={revenueFullScreen ? "card fullscreen" : "card"}>
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title m-0">
                      <i className="fa fa-pie-chart me-2"></i>Revenue
                      Distribution
                    </h6>
                    <Link
                      className="card-fullscreen"
                      onClick={handleFullScreen3}
                    >
                      <i className="icon-size-fullscreen"></i>
                    </Link>
                  </div>
                  <div className="card-body">
                    {revenueSeries.length > 0 && (
                      <ReactApexChart
                        options={revenueOptions}
                        series={revenueSeries}
                        type="donut"
                        height={320}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const DashboardCard = ({ title, value, img, money, accentClass }) => {
  const isFontAwesomeIcon = typeof img === "string" && img.startsWith("fa-");
  const normalizedNumber = Number(
    typeof value === "string" ? value.replace(/[^0-9.-]/g, "") : value || 0,
  );

  return (
    <div className={`crm-kpi-card ${accentClass || ""}`}>
      <div className="card-body d-flex align-items-center p-3">
        <div className="crm-kpi-icon overflow-hidden d-flex align-items-center justify-content-center">
          {isFontAwesomeIcon ? (
            <i className={`fa ${img} fa-lg`} aria-hidden="true"></i>
          ) : (
            <img
              src={img}
              className="img-fluid"
              alt={title}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}
        </div>
        <div className="flex-fill ms-3 text-truncate">
          <div className="crm-kpi-label">{title}</div>
          <div className="crm-kpi-value">
            {money
              ? formatCurrency(normalizedNumber)
              : Number.isNaN(normalizedNumber)
                ? value
                : normalizedNumber.toLocaleString()}
          </div>
          <div className="crm-kpi-meta">
            {money
              ? "Financial metric"
              : `${formatCompact(normalizedNumber)} total`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Crm;
